export default {
  websiteBaseUrl: 'https://www.vusocial.com',
  apiBaseUrl: 'https://www.vusocial.com/api',
  dashboardBaseUrl: 'https://www.vusocial.com/dashboard',
  imgBaseUrl: 'https://img.vusocial.com',
  useProxyForApiCall: false,
  auth: {
    loginUrl: 'https://www.vusocial.com/login',
    loginApiUrl: 'https://www.vusocial.com/api/user/login',
    userAuthenticationUrl: 'https://www.vusocial.com/api/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  webEngage: {
    licenseCode: '82617805',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'staging',
  },
  stripe: {
    key: 'pk_live_IAgqhpYJDVyC18JAWuWJc7dP',
  },
};
